var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('EditorSideControlsMobile',_vm._g(_vm._b({},'EditorSideControlsMobile',_vm.editorSideControlsProps,false),_vm.editorSideControlsEmits)):_c('EditorSideControlsDesktop',_vm._g(_vm._b({},'EditorSideControlsDesktop',_vm.editorSideControlsProps,false),_vm.editorSideControlsEmits))
}
var staticRenderFns = []

export { render, staticRenderFns }